import Vue from 'vue';
import VTooltip from 'v-tooltip';

import router from './router';
import store from './store';
import App from './App';
import measures from './mixins/measures';
import presets from './mixins/presets';
import './icons';

Vue.config.productionTip = false;
Vue.use(VTooltip, {
    defaultTrigger: 'hover click'
});
Vue.mixin(measures);
Vue.mixin(presets);

window.addEventListener('resize', () => {
    store.commit('setWindowSize', window.innerWidth);
});

window.model = new Vue({
    el: '#app',
    router,
    store,
    render (createElement) {
        return createElement(App);
    },
    mounted () {
        gtag('event', 'load', {
            'event_label': 'App loaded',
            'event_category': 'technical',
            'non_interaction': true
        });
    }
});
